"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.module.scss");
var classcat_1 = require("classcat");
var ResizeContext_1 = require("./ResizeContext");
var Column_1 = require("./Column");
function ResizableColumn(_a) {
    var _b;
    var children = _a.children, className = _a.className, index = _a.index, ref = _a.ref, others = tslib_1.__rest(_a, ["children", "className", "index", "ref"]);
    var column = ref || React.useRef();
    var context = React.useContext(ResizeContext_1.default);
    var _c = React.useState({
        startX: 0,
        clientX: -1,
        mouseDown: false
    }), resizeValue = _c[0], setResizeValue = _c[1];
    var calculateNextWidth = React.useCallback(function (clientX, resizeEnabled) {
        window.requestAnimationFrame(function () {
            var parentLeft = column.current.getBoundingClientRect().left;
            var startX = resizeValue.startX;
            var left = parentLeft;
            var width = (clientX - parentLeft) + startX;
            context.setResizeHandler(resizeEnabled, { left: left, width: width, index: index });
        });
    }, [resizeValue]);
    var onMouseDown = React.useCallback(function (e) {
        e.stopPropagation();
        e.preventDefault();
        var parentRect = column.current.getBoundingClientRect();
        var clientX = e.clientX;
        setResizeValue({
            startX: parentRect.left + parentRect.width - clientX,
            mouseDown: true,
            clientX: clientX,
        });
        return false;
    }, [column]);
    var onMouseMove = React.useCallback(function (e) {
        window.requestAnimationFrame(function () {
            var clientX = e.clientX;
            setResizeValue(function (prev) { return (tslib_1.__assign({}, prev, { clientX: clientX })); });
        });
    }, [column]);
    var onMouseUp = React.useCallback(function (e) {
        setResizeValue(function (prev) { return (tslib_1.__assign({}, prev, { mouseDown: false })); });
    }, []);
    React.useEffect(function () {
        if (resizeValue.clientX > -1) {
            calculateNextWidth(resizeValue.clientX, resizeValue.mouseDown);
        }
    }, [resizeValue]);
    React.useEffect(function () {
        if (resizeValue.mouseDown) {
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", onMouseUp);
            return function () {
                document.removeEventListener("mousemove", onMouseMove);
                document.removeEventListener("mouseup", onMouseUp);
            };
        }
    }, [resizeValue.mouseDown, column]);
    return (React.createElement(Column_1.default, tslib_1.__assign({}, others, { ref: column, className: classcat_1.default([theme.resizableColumn, className]) }),
        children,
        React.createElement("div", { className: classcat_1.default([theme.resizeHandler, (_b = {},
                    _b[theme.active] = resizeValue.mouseDown,
                    _b)]), onMouseDown: onMouseDown })));
}
exports.default = React.memo(ResizableColumn);
